import {NgModule} from '@angular/core';
import {InactiveLicensesInformationService} from './inactive-licenses-information.service';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    providers: [
        InactiveLicensesInformationService
    ]
})
export class InactiveLicensesInformationModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/inactive/inactive-licenses-information.module.ts